(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("namefully"));
	else if(typeof define === 'function' && define.amd)
		define("namefully", ["React", "namefully"], factory);
	else if(typeof exports === 'object')
		exports["namefully"] = factory(require("React"), require("namefully"));
	else
		root["namefully"] = factory(root["React"], root["namefully"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 